import Sidebar from "./components/sidebar/Sidebar";
import Topbar from "./components/topbar/Topbar";
import "./App.css";
import Home from "./pages/home/Home";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import UserList from "./pages/userList/UserList";
import User from "./pages/user/User";
import NewUser from "./pages/newUser/NewUser";
import ProductList from "./pages/productList/ProductList";
import Product from "./pages/product/Product";
import NewProduct from "./pages/newProduct/NewProduct";
import Main from "./store/pages/Main";
import { useEffect } from "react";
import { useProductsContext } from "./hooks/useProductsContext";
import ShoppingCart from "./store/pages/Cart";
import Navbar from "./store/components/Navbar";
import Signup from "./store/pages/Signup";
import Login from "./store/pages/Login";
import { useAuthContext } from "./store/hooks/useAuthContext";


function App() {

  const {dispatch} = useProductsContext()
  const {user} = useAuthContext()
    useEffect(() => {
      
      const fetchData = async () => {
        try {
          const response = await fetch('https://fashionforwardd.azurewebsites.net/api/products');
          if (!response.ok) {
            throw new Error('Failed to fetch products');
          }
          const json = await response.json();
          dispatch({ type: 'SET_PRODUCTS', payload: json });
        } catch (error) {
          // Handle error
          console.error(error);
        }
      };
  
      fetchData();

    },[dispatch])
  return (
    <Router>
{window.location.pathname === "/" ?

     <>
     <Navbar/>
<Routes> 
<Route path="/" exact element={ <Main />} />
<Route path="/cart" element={ <ShoppingCart />} />
<Route path="/signupuser" element={!user ?  <Signup /> : <Navigate to="/" /> } />
<Route path="/loginuser" element={<Login />  } />

</Routes>

 </>
:
<>
<Topbar />
      <div className="container">
        <Sidebar />
        <Routes>
 
             {/* Store UI Routes */}
             <Route path="/admin" element={ <Home />} />
         
          <Route path="/users" element={ <UserList />} />
          
          <Route path="/user/:userId" element={ <User />} />
      
          <Route path="/newUser" element={ <NewUser />} />
       
          <Route path="/products"  element={ <ProductList />} />
        
          <Route path="/product/:productId" element={ <Product />} />
          
          <Route path="/newproduct" element={ <NewProduct />} />
          <Route path="/signupuser" element={!user ?  <Signup /> : <Navigate to="/" /> } />
        {/* <Route path="/loginuser" element={<Login />  } /> */}
         
        </Routes>
      </div>
      </>


}

  
    </Router>
  );
}


export default App;
